import { jwtDecode } from 'jwt-decode';
import AppConfig from '../AppConfig';
import Cookies from 'js-cookie';

export type JWTPayload = {
  exp?: number;
  memberId: string;
  organisationId: string;
  emailId: string;
  source: 'MEMBERS' | 'IAM';
  d2cUserId: string;
};

function isTokenExpired(jwtPayload: JWTPayload): boolean {
  const now = Date.now() / 1000; // current time in seconds
  return !!(jwtPayload.exp && jwtPayload.exp < now);
}

function decodeAuthToken(
  token: string = Cookies.get(AppConfig.JWT_TOKEN_COOKIE_NAME) as string
): JWTPayload | null {
  if (token) {
    const decoded = jwtDecode<JWTPayload>(token);
    if (decoded && !isTokenExpired(decoded)) {
      return decoded;
    }
    return null;
  }
  return null;
}

function getUserInfo(): JWTPayload | null {
  const parsedToken = getToken();
  if (!parsedToken) {
    return null;
  }
  return decodeAuthToken(parsedToken);
}

function getToken(): string | null {
  const token = Cookies.get(AppConfig.JWT_TOKEN_COOKIE_NAME);
  if (!token) {
    return null;
  }
  return token;
}

function verifyTokenAndInit(token: string) {
  window.dev.i('VERIFYING TOKEN:', { token });
  const isTokenValid = decodeAuthToken(token);
  window.dev.i('IS TOKEN VALID:', { isTokenValid });
  if (isTokenValid) {
    Cookies.set(AppConfig.JWT_TOKEN_COOKIE_NAME, token, {
      domain: '.plumhq.com',
    });
  } else {
    window.dev.i('INVALID TOKEN:', { token });
  }
}

export {
  getUserInfo,
  getToken,
  decodeAuthToken,
  isTokenExpired,
  verifyTokenAndInit,
};
